import React from 'react';
import { motion } from 'framer-motion';
import { ContactForm } from '../components/ContactForm';
import { MailIcon, MessageCircleIcon, HelpCircleIcon } from 'lucide-react';
const infoCards = [{
  icon: MailIcon,
  title: 'Email Us',
  description: 'We typically respond within 24 hours',
  color: 'primary'
}, {
  icon: MessageCircleIcon,
  title: 'For Parents',
  description: 'Questions about features, pricing, or getting started',
  color: 'surface'
}, {
  icon: HelpCircleIcon,
  title: 'For Educators',
  description: 'Bulk licensing, classroom integration, and support',
  color: 'warm'
}];
const colorMap = {
  primary: 'from-m3-on-surface to-m3-on-surface-light',
  surface: 'from-m3-surface to-m3-on-surface-light',
  warm: 'from-word-current to-word-error-light'
};
export function ContactPage() {
  return <div className="w-full pt-24 pb-16 bg-gradient-to-b from-m3-primary via-m3-surface to-m3-surface-container min-h-screen relative overflow-hidden" data-id="element-114">
      {/* Pixel Grid Background */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `
          linear-gradient(0deg, transparent 24%, rgba(13, 112, 128, 0.3) 25%, rgba(13, 112, 128, 0.3) 26%, transparent 27%, transparent 74%, rgba(13, 112, 128, 0.3) 75%, rgba(13, 112, 128, 0.3) 76%, transparent 77%, transparent),
          linear-gradient(90deg, transparent 24%, rgba(13, 112, 128, 0.3) 25%, rgba(13, 112, 128, 0.3) 26%, transparent 27%, transparent 74%, rgba(13, 112, 128, 0.3) 75%, rgba(13, 112, 128, 0.3) 76%, transparent 77%, transparent)
        `,
      backgroundSize: '40px 40px'
    }} data-id="element-115"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-116">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-117">
          <h1 className="text-5xl sm:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-m3-on-surface to-m3-outline mb-4 uppercase" style={{
          textShadow: '0 0 30px rgba(13,112,128,0.2)'
        }} data-id="element-118">
            Contact Quest
          </h1>
          <p className="text-base text-m3-on-surface-variant max-w-2xl mx-auto leading-relaxed" data-id="element-119">
            Have questions about Snow Day? We'd love to hear from you. Send us a
            message and we'll respond as soon as possible.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-120">
          {/* Contact Info Cards */}
          <div className="lg:col-span-1 space-y-6" data-id="element-121">
            {infoCards.map((card, index) => <motion.div key={index} className="bg-white/80 p-6 border-4 border-m3-on-surface rounded-lg backdrop-blur-sm hover:border-m3-outline transition-colors" initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            scale: 1.05,
            boxShadow: '0 0 30px rgba(13,112,128,0.2)'
          }} data-id="element-122">
                <div className={`bg-gradient-to-br ${colorMap[card.color as keyof typeof colorMap]} w-14 h-14 rounded-lg flex items-center justify-center mb-4 border-2 border-white`} data-id="element-123">
                  <card.icon className="w-7 h-7 text-white" data-id="element-124" />
                </div>
                <h3 className="text-lg font-bold text-m3-outline mb-2 uppercase tracking-wide" data-id="element-125">
                  {card.title}
                </h3>
                <p className="text-m3-on-surface-variant text-sm leading-relaxed" data-id="element-126">
                  {card.description}
                </p>
              </motion.div>)}
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-127">
            <motion.div className="bg-white/80 p-8 border-4 border-m3-on-surface rounded-lg backdrop-blur-sm screen-glow" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} data-id="element-128">
              <h2 className="text-3xl font-bold text-m3-outline mb-6 uppercase tracking-wider" data-id="element-129">
                Send Message
              </h2>
              <ContactForm data-id="element-130" />
            </motion.div>
          </div>
        </div>
      </div>
    </div>;
}